import styles from './styles.module.css';
import { formatAuthorNames } from '@/shared/functions/formatAthorNames'

const Autores = ({ authors }) => {

    return (
        <div className={`${styles['container-authors']}`}>
            {
                authors && authors.map(({ name, imageUrl, secondaryImageUrl, slug, _id }) => {
                    const authorNames = formatAuthorNames(name);
                    imageUrl = imageUrl ? imageUrl.replace('http://', 'https://') : secondaryImageUrl ? secondaryImageUrl.replace('http://', 'https://') : '';
                    return (
                        <div className={styles['card-author']} key={_id}>
                            <img
                                src={imageUrl}
                                alt={`Foto ${authorNames}`}
                                loading="lazy"
                            />
                            <h2>{authorNames}</h2>
                            <a
                                href={`/autor/${slug}`}
                                className={styles['card-cta']}
                                title={`Ver más notas de ${authorNames}`}
                            >
                                VER NOTAS
                            </a>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Autores;
